module.exports = __webpack_public_path__ + "59cab6a380c46803e4d05abb48f16b87.svg";